import { createContext, useContext } from 'react';

export const EntraOAuthContext = createContext<{
    token: string;
}>({
    token: '',
});

export const useEntraOAuthContext = () => {
    return useContext(EntraOAuthContext);
};
